(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amm-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-amm-open-fit]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.ammOpenFit);
      if (!dialog) return;
      dialog.showModal();
      const selected = trigger.closest('product-info')?.querySelector('variant-radios input:checked[name*="Size"], variant-selects select[name*="Size"], variant-radios input:checked[name*="Waist"], variant-selects select[name*="Waist"]');
      const size = selected?.value?.match(/^\d+/)?.[0] || selected?.value?.split(' ')[0];
      dialog.querySelectorAll('[data-amm-size]').forEach(row => { if (row.dataset.ammSize === size) row.setAttribute('data-amm-current', ''); else row.removeAttribute('data-amm-current'); });
      const fit = trigger.closest('product-info')?.querySelector('variant-radios input:checked[name="Fit"], variant-selects select[name="options[Fit]"]')?.value;
      dialog.querySelectorAll('[data-amm-fit-name]').forEach(card => { if (card.dataset.ammFitName === fit) card.setAttribute('data-amm-selected', ''); else card.removeAttribute('data-amm-selected'); });
      return;
    }
    const close = event.target.closest('[data-amm-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    const unit = event.target.closest('[data-amm-unit]');
    if (unit) {
      const dialog = unit.closest('dialog');
      dialog.dataset.unit = unit.dataset.ammUnit;
      dialog.querySelectorAll('[data-amm-unit]').forEach(button => button.setAttribute('aria-pressed', String(button === unit)));
      dialog.querySelectorAll('.amm-fit__unit-label').forEach(label => { label.textContent = unit.dataset.ammUnit; });
    }
  });
  document.addEventListener('click', event => {
    const dialog = event.target.closest('dialog[data-amm-fit]');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
